import BaseTheme from '../base';

export default {
  ...BaseTheme.Colors,
  primary: '#1154FF',
  interaction: '#1154FF',
  primaryLight: '#1163fb',
  light: '#627793',
  inputBackground: '#F2F2F2'
};
